import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/destinationActivity'

export const destinationActivityService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
    reorderItems
};


//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

//show
function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', {})
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}

function reorderItems(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/reorder`, 'POST', { data: data });
}